import React from 'react';
import styled from 'styled-components';
import plusicon from '../../../images/plusicon.png';
import { Link } from 'react-router-dom';
import appInfoContainer from '../../../auth/appInfoContainer';

// 진행중인 프로젝트 리스트
export default function MyjoinGrouplist(props) {
  //두개의 날짜를 비교하여 차이를 알려준다.
  function dateDiff(_date1, _date2) {
    var diffDate_1 = _date1 instanceof Date ? _date1 : new Date(_date1);
    var diffDate_2 = _date2 instanceof Date ? _date2 : new Date(_date2);

    diffDate_1 = new Date(
      diffDate_1.getFullYear(),
      diffDate_1.getMonth() + 1,
      diffDate_1.getDate(),
    );
    diffDate_2 = new Date(
      diffDate_2.getFullYear(),
      diffDate_2.getMonth() + 1,
      diffDate_2.getDate(),
    );

    var diff = Math.abs(diffDate_2.getTime() - diffDate_1.getTime());
    diff = Math.ceil(diff / (1000 * 3600 * 24));

    return diff;
  }
  const projectzero = () => {
    if (props.item.length === 0) {
      return <SubTitle></SubTitle>;
    } else if (props.item.length > 0) {
      return props.item.map((value) => {
        return (
          <Pjlist key={`joined-group-item-no-${value['no']}`}>
            <Link to={`/group/${value['group_no']}/project/${value.no}`}>
              <Pjimages>
                <Img
                  src={
                    appInfoContainer.imagePath +
                    '/group_project_cover_img/' +
                    value.cover_img
                  }
                />
              </Pjimages>
              <Imgtextbox>
                {new Date(value.start_date).getTime() > new Date().getTime() ? (
                  parseInt(dateDiff(value.start_date, new Date())) === 1 ? (
                    <Subtit>마감임박</Subtit>
                  ) : (
                    <Subtit>D-{dateDiff(value.start_date, new Date())}</Subtit>
                  )
                ) : new Date(value.end_date) >= new Date().getTime() ? (
                  new Date(value.start_date).getTime() <=
                  new Date().getTime() <=
                  new Date(value.end_date) ? (
                    <Subtit>진행중</Subtit>
                  ) : null
                ) : null}
                <Pjday>
                  {new Date(value.start_date).getMonth() + 1}/
                  {new Date(value.start_date).getDate()}
                  &nbsp; - &nbsp;
                  {new Date(value.end_date).getMonth() + 1}/
                  {new Date(value.end_date).getDate()}
                </Pjday>
                <Maintit>&nbsp;{value.title}</Maintit>
              </Imgtextbox>
            </Link>
          </Pjlist>
        );
      });
    }
  };

  return (
    <GrouProjectinner>
      {/* 숫자 카운트 하는 방법 */}
      <Title>
        {props.title} <Num>{props.item.length}</Num>
      </Title>

      <Pjlistarea>
        {projectzero()}
        {/* <SubTitle>모임과 관련된 세부적인 프로젝트를 만들 수 있어요!</SubTitle>
                {
                    props.data.map((value)=>
                        {return <Projectlsit
                            value={value}
                            />
                        })
                } */}
      </Pjlistarea>

      {/* 방장 계정일때 보이는것 같음 */}
      <Link
        component={Pjbtn}
        to={`/group/${props.no}/project/create`}
        display={props.display}
      >
        {' '}
        <Plusicon>
          <img src={plusicon}></img>
        </Plusicon>{' '}
        프로젝트 만들기
      </Link>
    </GrouProjectinner>
  );
}

const GrouProjectinner = styled.div`
  padding-left: calc(100vw * (16 / 375));
  // padding-bottom : calc(100vw*(102/375));
  // padding-bottom : ${(props) => props.paddingBottom};
`;

const Title = styled.h1`
  font-size: calc(100vw * (18 / 375));
  font-weight: bold;
  padding: calc(100vw * (22 / 375)) 0 calc(100vw * (13 / 375));
`;
const Num = styled.span`
  color: #7f7f7f;
`;
const Pjimages = styled.span`
  display: block;
  width: calc(100vw * (144 / 375));
  height: calc(100vw * (144 / 375));
  border-radius: 50%;
  filter: brightness(0.38);
  overflow: hidden;
`;
const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
const Pjlistarea = styled.ul`
  width: 100%;
  padding-top: calc(100vw * (15 / 375));
  white-space: nowrap;
  overflow-y: visible;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  // 스크롤바 숨기기
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;
const Pjlist = styled.li`
  display: inline-block;
  position: relative;
  margin-right: calc(100vw * (18 / 375));
  cursor: pointer;
`;
const Imgtextbox = styled.ul`
  position: absolute;
  display: inline-block;
  text-align: center;
  width: 100%;
  top: calc(100vw * (19 / 375));
  left: 50%;
  transform: translateX(-50%);
`;
const Subtit = styled.li`
  display: inline-block;
  padding: 0 calc(100vw * (6 / 375));
  height: calc(100vw * (18 / 375));
  border-radius: calc(100vw * (13 / 375));
  background-color: #ffcf19;
  font-size: calc(100vw * (10 / 375));
  font-weight: bold;
  line-height: calc(100vw * (18 / 375));
  text-align: center;
  color: #4e4e4e;
  margin-bottom: calc(100vw * (4 / 375));
`;
const Pjday = styled.li`
  font-size: calc(100vw * (12 / 375));
  // font-weight: 500;
  line-height: 1.5;
  color: #eaeaea;
`;
const Maintit = styled.li`
  display: inline-block;
  font-size: calc(100vw * (16 / 375));
  line-height: 1.5;
  color: #ffffff;
  font-weight: 500;
  white-space: break-spaces;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  height: auto;
  max-height: calc(100vw * (48 / 375));
  width: calc(100vw * (100 / 375));
  margin: 0 auto;
`;

const Plusicon = styled.span`
  display: block;
  width: calc(100vw * (12 / 375));
  height: calc(100vw * (12 / 375));
  margin-right: calc(100vw * (8 / 375));
`;
const Pjbtn = styled.a`
  display: flex;
  display: ${(props) => props.display};
  justify-content: center;
  align-items: center;
  width: calc(100vw * (341 / 375));
  height: calc(100vw * (53 / 375));
  border-radius: calc(100vw * (3 / 375));
  background-color: #ffcf19;
  font-size: calc(100vw * (16 / 375));
  font-weight: 500;
  color: #4e4e4e;
  margin-top: calc(100vw * (32 / 375));
`;
const SubTitle = styled.p`
  font-size: calc(100vw * (11 / 375));
  letter-spacing: calc(100vw * (0.15 / 375));
  color: #7f7f7f;
  margin-top: calc(100vw * (-15 / 375));
`;
